module.exports = __webpack_public_path__ + "static/media/how-we-do-it-art.df640280.png";